import { RouterStore } from 'mobx-react-router';

export const routingStore = new RouterStore();
